<template>
    <div class="creator_detail_wrap">
        <utility-detail-component :utilityType="'utilityDetail'" :utilityKey="utilityKey"></utility-detail-component>
        <utility-detail-modal></utility-detail-modal>
    </div>
</template>


<script>
import UtilityDetailComponent from '@/components/utility/UtilityDetailComponent';
import UtilityDetailModal from "@/components/modal/UtilityDetailModal.vue";
export default {
    name: "UtilityDetail",
    mixins: [],
    components: {UtilityDetailModal, UtilityDetailComponent },
    props: {

    },
    data() {
        return {
            utilityKey: Number(this.$route.params.idx),
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {

    },
    methods: {
    },
    watch: {
    },
}
</script>
